export interface IUser {
    id: string;
    createdAt: string;
    updated_date: string;
    email: string;
    telegram: string;
    phone: string;
    first_name: string;
    middle_name: string;
    role_id: number;
    status_id: number;
    company_id: string;
    avatar_path: string;
    is_admin: boolean;
    /** Согласия (152-ФЗ) — приходят из /auth/me. */
    needs_consent?: boolean;
    consent_withdrawn?: boolean;
    /** Cookie-выбор — приходят из /auth/me. */
    needs_cookie_choice?: boolean;
    cookie_analytics_enabled?: boolean;
    /**
     * Текущие версии submittable-документов из /auth/me — чтобы оверлеи не
     * делали отдельный GET /legal/versions (формы регистрации, где нет
     * авторизации, по-прежнему используют публичный useLegalVersions).
     */
    legal_versions?: {
        terms_of_use: number | null;
        pd_consent: number | null;
        cookie_policy: number | null;
    };
}

export interface IUserWithPassport extends IUser {
    passport_series?: string;
    passport_number?: string;
    passport_issued_date?: string;
    passport_issued_whom?: string;
}

export const defaultUser: IUserWithPassport = {
    id: "",
    createdAt: "",
    updated_date: "",
    email: "",
    telegram: "",
    phone: "",
    first_name: "",
    middle_name: "",
    role_id: -1,
    status_id: 1,
    company_id: "",
    avatar_path: "",
    passport_series: "",
    passport_number: "",
    passport_issued_date: "",
    passport_issued_whom: "",
    is_admin: false,
};

export const userRoles = [
    {id: 1, title: "Руководитель"},
    {id: 2, title: "Водитель"},
    {id: 3, title: "Бухгалтер"},
    {id: 4, title: "Диспетчер"},
    {id: 5, title: "Механик"},
    {id: 6, title: "Снабженец"},
    {id: 7, title: "Слесарь"},
    {id: 8, title: "Электрик"},
    {id: 9, title: "Энергетик"},
    {id: 1000, title: "Гостевой доступ"},
];

export const userStatus = [
    {id: 1, title: "Работает"},
    {id: 2, title: "В отпуске"},
    {id: 3, title: "На больничном"},
    {id: 4, title: "Уволился"},
];

export const DIRECTOR_ROLE_ID = 1;

/**
 * Роли модуля диспетчеризации (зеркало бэкендовых констант
 * src/common/constants/roles.ts — источник истины один, id совпадают
 * с userRoles выше).
 *   - Водитель (2) — кабинет водителя: свой рейс, история, закрытие точек.
 *   - Диспетчер (4) — управление диспетчеризацией (без удаления из базы).
 * Доска диспетчеризации видна ролям 1 и 4, кабинет водителя — роли 2.
 */
export const DRIVER_ROLE_ID = 2;
export const DISPATCHER_ROLE_ID = 4;

/**
 * Роль «Гостевой доступ» — read-only пользователь.
 * Бэкенд режет любые мутации для этой роли guard'ом; на фронте по ней
 * включается read-only UX (см. useIsReadOnly). Один механизм и для
 * демо-режима, и для реальных компаний-наблюдателей.
 */
export const GUEST_ROLE_ID = 1000;
